<template>
  <lego-modal
    ref="modalTemplate"
    class="modal-event-card"
    :size="1104"
    :title="t('page.template.findEventTemplate')"
    medium
    @beforeClose="modalClose"
  >
    <!--템플릿 불러오기-->
    <ul class="event-card-list">
      <li v-for="(eventTemplateItem, index) in eventTemplateData" :key="index">
        <event-template-card :item="eventTemplateItem" @clickTemplate="onSelectedTemplate" />
      </li>
      <li class="no-data" v-if="eventTemplateData.length === 0">
        <!-- <lego-icon iconType="df" icon="add_box_40" :iconSize="40" /> -->
        <img src="@/assets/img/scmp/no_data.png" />
        {{ t('label.noData') }}
      </li>
    </ul>
    <template #action>
      <lego-button @click="modalClose">{{ t('button.cancel') }}</lego-button>
      <!--취소-->
      <lego-button :disabled="disableConfirmBtn" @click="checkSendIt" main>{{
        t('button.confirm')
      }}</lego-button>
      <!--확인-->
    </template>
  </lego-modal>
</template>
<script>
import EventTemplateCard from './EventTemplateCard.vue';
import i18nMixin from '@/mixins/i18n.mixin.js';
import moment from 'moment';

export default {
  mixins: [i18nMixin],
  name: 'EventTemplatePopup',
  emits: ['close:modal', 'selectedTemplate'],
  components: {
    EventTemplateCard
  },
  props: {
    resourceTypeModel: {
      type: String
    },
    resourceTypeModel2: {
      type: String
    },
    opt: {
      type: String
    }
  },
  data() {
    return {
      eventTemplateData: [],
      selectedItem: null
    };
  },
  // computed: {
  //    eventTemplateData() {

  //    },
  // },
  created() {
    //console.log("[created]");
    this.modalInit();
  },
  mounted() {
    this.$refs['modalTemplate'].open();
  },
  computed: {
    disableConfirmBtn() {
      return !this.eventTemplateData.length || !this.selectedItem;
    }
  },
  methods: {
    modalClose() {
      const message =
        `<div>` +
        this.t('message.notNotifyWritingInfo') +
        `</br>` +
        this.t('message.moveTheScreenNotify') +
        `</div>`;
      if (this.selectedItem) {
        this.$alert(message, this.t('page.eventStatus.notice'), {
          cancel: () => {},
          action: () => {
            this.$emit('close:modal');
          }
        });
      } else this.$emit('close:modal');
    },
    modalInit() {
      this.fetchData();
    },
    fetchData() {
      let param = {
        timeZone: window.sessionStorage.timeZoneInfo || moment.tz.guess(),
        page: 0,
        size: 100
      };

      this.$http.event
        .get('/v1/console/event-templates', param, true, false, {
          headers: { 'X-ResourceType': this.resourceTypeModel }
        })
        .then((data) => {
          //console.log("[이벤트 템플릿 목록 data]:: ", data);
          if (data && data.contents) {
            let objectType = '';
            // if (this.resourceTypeModel === 'Kubernetes') {
            //     for (let i = 0; i < data.contents.length; i++) {
            //         let _row = data.contents[i];
            //         let objectTypeTemp = ((_row.objectType == null) ? "cluster" : _row.objectType.toLowerCase());
            //         objectType = ['deployment', 'replicaset', 'statefulset', 'daemonset'].includes(objectTypeTemp) ? 'workload' : objectTypeTemp;
            //         if (this.opt == "") {
            //             this.opt = "cluster";
            //         }
            //         // data.contents[i].mine 존재이유 모르겠음
            //         if ((this.resourceTypeModel === 'Kubernetes') && (this.opt.toLowerCase() === objectType)) {
            //             data.contents[i].mine = true;
            //             //this.eventTemplateData = _row;
            //             //console.log('last eventTemplateData = ' + this.eventTemplateData);
            //         } else {
            //             data.contents[i].mine = false;
            //         }
            //     }
            // } else
            if (this.$util.getLstSubResourceType().includes(this.resourceTypeModel)) {
              data.contents = data.contents.filter((item) => {
                return (
                  item.productTypeCode == this.resourceTypeModel &&
                  item.objectType == this.resourceTypeModel2
                );
                // ||  // 하위 타입이 같을 경우
                // (
                //     // Kubernetes일경우 workload 일경우 objectType이 달라도 노출
                //     this.$util.getK8sWorkloadList().includes(item.objectType) && this.$util.getK8sWorkloadList().includes(this.resourceTypeModel2)
                // )
              });
            }
            data.contents.forEach(function (content) {
              content.selected = false;
            });

            this.eventTemplateData = data.contents;
            // this.eventTemplateData = data.contents.filter(
            //     item => item.mine === true
            // );
          }
        });
    },
    onSelectedTemplate(item) {
      this.selectedItem = item;
      this.eventTemplateData.forEach(function (eventTemplateItem) {
        eventTemplateItem.selected = eventTemplateItem.eventTemplateSq === item.eventTemplateSq;
      });
      // this.selectedItem = item;
      // this.$emit("selectedTemplate", this.selectedItem)
      // this.modalClose()
    },

    // 확인버튼을 사용할지 여부 기획문의중.....
    checkSendIt() {
      if (this.selectedItem) {
        this.$modal.open({
          rootId: 'app',
          type: 'confirm',
          title: this.$t('title.notice'),
          message: `<div>` + this.$t('page.template.selectTemplate') + `</div>`,
          action: () => {
            this.$emit('selectedTemplate', this.selectedItem);
            this.$emit('close:modal');
          },
          cancel: () => {}
        });
      } else {
        this.$alert(this.t('page.eventStatus.selectTemplate'));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
:deep .lego-modal__body {
  padding: 13px 32px 13px 32px !important;
}
.event-card-list {
  margin: 0 -11px;

  &:after {
    content: '';
    clear: both;
    display: table;
  }

  & > li {
    float: left;
    width: 25%;
    padding: 11px;
  }

  & > li.no-data {
    width: 100%;
    height: 120px;
    border-bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #cccccc;
  }
  .event-template-card {
    margin-bottom: 0px;
  }
}
</style>
